<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ activeText ? activeText : productApplication.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ currentLang.config.navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="toPath()">{{ productProgramPage.title }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeText">
            <span class="is-link-1" @click="false && $router.go(-1)">{{ activeText }}</span>
          </el-breadcrumb-item>
          <!-- <el-breadcrumb-item v-if="activeNameText !== ''">{{
            activeNameText
          }}</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
    </div>
    <div class="zp_wrap">
      <h2>{{ detailsInfo[`${currentLang.prefix}title`] }}</h2>
      <div class="wrap_one">
        <div>{{ detailsInfo.publish_time_txt ? detailsInfo.publish_time_txt : detailsInfo.create_time_txt }}</div>
        <span v-if="detailsInfo.activeNameText">{{detailsInfo.activeNameText}}</span>
      </div>
      <p>
        {{ detailsInfo[`${currentLang.prefix}summary`] }}
      </p>
	    <div class="img_wrap">
	      <img :src="detailsInfo.full_image" alt="" />
	    </div>
	    <div class="detail_wrap1" v-html="detailsInfo[`${currentLang.prefix}content`]"></div>

      <!-- 返回按钮 -->
      <div style="width:100%;margin:30px 0 0;display:flex;justify-content:flex-end;border-bottom:1px solid #ccc;">
        <back-button>
          <i slot="prefixIcon"></i>
          返回上一级
          <i slot="suffixIcon" class="el-icon-arrow-right"></i>
        </back-button>
      </div>
    </div>


    <div class="wap2" v-if="from && from == 1 && footArticleList.length >= 0">
      <div
        class="wap2-content"
        style="display: flex; justify-content: space-between"
      >
        <div class="box" v-for="(item, i) in footArticleList.slice(0, 2)" :key="i">
          <div class="image-container">
            <img :src="item.full_image" alt="" />
          </div>
          <div class="other-container">
            <h3 class="wap2__title">{{ item[`${currentLang.prefix}title`] }}</h3>
            <p v-html="item[`${currentLang.prefix}summary`]"></p>
            <div class="wap2__btn" @click="goDetail(item, item.cate[`${currentLang.prefix}cate_name`])">{{ productProgramPage.programDetail.footArticleBtnTxt }}</div>
          </div>
        </div>
      </div>
    </div>
    

    <footer-wrap></footer-wrap>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import { getCateDetailInfo, getCase } from "@/utils/http.js";


export default {
  data() {
    return {
      detailsInfo: {},
      footArticleList: [],
      activeText: '',
      from: '',
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    productApplication() {
      return this.currentLang.config.productApplication
    },
    productProgramPage() {
      return this.currentLang.config.productProgramPage
    },
    sustainableDevelopment() {
      return this.currentLang.config.aboutPage.sustainableDevelopment
    }
  },
  
  created() {
    if (this.$route.query.from) {
      this.from = this.$route.query.from
    }
  },

  mounted() {
    this.getDetails();
  },

  methods: {
    toPath() {
      this.$router.push({
        path: '/cpProgram'
      })
    },

    getDetails() {
      if (this.$route.query.activeNameText) {
        this.activeText = this.$route.query.activeNameText
      }
      else if (this.$route.query.activeName) {
        const activeName = this.$route.query.activeName
        this.activeText = this.productProgramPage.tabs[activeName - 1] ? this.productProgramPage.tabs[activeName - 1] : ''
      }
      getCase({
          id: this.$route.query.sonId || this.$route.query.id || ''
        }).then(res => {
          if (res.code === 1) {
            this.detailsInfo = res.data;
            this.footArticleList = res.data && res.data.case_gl ? res.data.case_gl : []
          }
	        console.log('this.detailsInfo',this.detailsInfo)
        });
    },

    goDetail(info, nameTxt) {
      this.$router.push({
        path: "/programDetail",
        query: { id: info.id, activeNameText: nameTxt }
      });
    },
  }
};
</script>
<style lang="scss" scoped>

.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}
.zp_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1000px;
  width: 1200px;
  height: auto;
  margin: 120px auto 80px;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
  }

  p {
    color: #777777;
  }
}

.wrap_one{
  display: flex;
  font-size: 16px;
  justify-content: center;
  margin: 0px 0 20px;
  text-align: center;
  div{
    color: #999999;
  }
  span{
    color: #30506F;
    margin-left: 20px;
  }
}

.img_wrap {
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
  }
}
.detail_wrap1 {
	margin-bottom: 60px;
	font-size: 14px;
	line-height: 30px;
	text-indent: 2rem;
	color: #656565;
  img {
    width: 100%;
    height: auto;
  }
}

.wap2 {
  // padding-top: 80px;
  padding-bottom: 80px;
  // background: #f5f5f5;

  .box {
    background-color: #f5f5f5;
    color: #333;
    border: 1px solid #ececec;
  }

  .wap2-content {
    width: 1200px;
    margin: 0 auto 0;
    text-align: left;
    .image-container {
      width: 580px;
      height: 350px;
      overflow: hidden;
      background-color: #fff;
    }
    /* 鼠标经过图片放大动效 */
    .image-container :hover {
      transition: all 0.5s;
      transform: scale(1.1);
    }

    img {
      width: 100%;
      height: 100%;
      display: flex;
      object-fit: contain;
    }

    .other-container {
      width: calc(580px - 60px);
      // height: calc(280px - 60px);
      margin: 30px;
      text-align: justify;

      .wap2__title {
        color: var(--main-color-blue);
        font-weight: 500;
        font-size: 22px;
        padding: 0 0px;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        line-clamp: 1;
        -webkit-line-clamp: 1;
        text-align: justify;
      }

      .wap2__btn {
        display: inline-block;
        padding: 10px 30px;
        background: #e8363e;
        color: #fff;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
      }

      p {
        height: 82px;
        margin: 20px 0 30px;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        line-clamp: 3;
        -webkit-line-clamp: 3; //显示几行
        font-size: var(--text-size-normal);
        line-height: 1.8;
        text-align: justify;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cpProgram/programDetail.vue